import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { api } from 'lib/axios';
import { SignUpError, SignUpRequest, SignUpResponse } from './types';

export const useSignUp = () => {
  const { isError, isLoading, data, mutateAsync, error } = useMutation<
    SignUpResponse,
    AxiosError<SignUpError>,
    SignUpRequest,
    SignUpResponse
  >((args) => api.post('/auth/register', args).then((res) => res.data));

  return {
    signUp: mutateAsync,
    isError,
    isLoading,
    data,
    error,
  };
};
